import React, {useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {useNavigate, useLocation} from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import {
  Alert,
  Snackbar,
  Grid,
  TextField,
  Card,
  AppBar,
  Typography,
  FormHelperText
} from "@mui/material";
import MDButton from "components/MDButton";
import {POST} from "APIclient";
import {LocalizationProvider, DatePicker} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {FormControl, InputLabel, Select, MenuItem} from "@mui/material";
import properties from "constants/ApplicationConstants";

function ChangeNoticePeriod() {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const employee = location.state?.employee || {};

  const [open, setOpen] = useState(false);
  const [snakColor, setSnakColor] = useState("");
  const [snakMessage, setSnakMessage] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [formData, setFormData] = useState({
    noticePeriod: "",
    extensionPeriod: ""
  });

  const [errors, setErrors] = useState({
    noticePeriod: "",
    extensionPeriod: ""
  });

  useEffect(() => {
    setIsButtonDisabled(!(formData.noticePeriod && formData.extensionPeriod));
  }, [formData.noticePeriod, formData.extensionPeriod]);

  const handleClose = () => setOpen(false);

  const handleChange = event => {
    const {name, value} = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));

    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: ""
    }));
  };

  const validateFields = () => {
    let tempErrors = {};
    let isValid = true;

    if (!formData.noticePeriod) {
      tempErrors.noticePeriod = "Resignation notice period month is required.";
      isValid = false;
    }

    if (!formData.extensionPeriod) {
      tempErrors.extensionPeriod = "Termination notice period month is required.";
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  const handleSubmit = async () => {
    const resignationNotice = Number(formData.noticePeriod);
    const terminationNotice = Number(formData.extensionPeriod);
    const url = `admin/changeNoticePeriod?empID=${employee.empId}&resignationNotice=${resignationNotice}&terminationNotice=${terminationNotice}`;

    try {
      if (!validateFields()) {
        return;
      }
      const response = await POST(url);
      if (response.status === 200) {
        setSnakColor("success");
        setSnakMessage("Notice period updated successfully.");
        setTimeout(() => {
          navigate("/employeeProbationReports");
        }, 2000);
      } else {
        setSnakColor("error");
        setSnakMessage("Failed to update notice period.");
      }
    } catch (error) {
      console.error("Error updating notice period:", error);
      setSnakColor("error");
      setSnakMessage("Error updating notice period.");
    } finally {
      setOpen(true);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <MDBox container sx={{minHeight: "100vh", width: "98%"}}>
          <AppBar position="static">
            <Card>
              <MDBox
                pt={2}
                mb={0}
                pb={4}
                px={4}
                sx={{borderRadius: "5px", border: "1px solid #D3D3D3"}}
              >
                <Typography
                  sx={{fontSize: "16px", fontWeight: "600", fontFamily: properties.fontFamily}}
                  color="textPrimary"
                >
                  {" "}
                  General Details
                </Typography>
                <MDBox display="flex" flexDirection="column" pt={2}>
                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{
                          fontSize: "14px",
                          fontWeight: "600",
                          minWidth: "150px",
                          fontFamily: properties.fontFamily
                        }}
                      >
                        Employee ID:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {employee.empId || "-"}
                      </MDTypography>
                    </Grid>
                    <Grid item xs={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{
                          fontSize: "14px",
                          fontWeight: "600",
                          minWidth: "150px",
                          fontFamily: properties.fontFamily
                        }}
                      >
                        Employee Name:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {employee.empName || "-"}
                      </MDTypography>
                    </Grid>

                    {/* Probation Start & End Date in One Row */}
                    <Grid item xs={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{
                          fontSize: "14px",
                          fontWeight: "600",
                          minWidth: "150px",
                          fontFamily: properties.fontFamily
                        }}
                      >
                        Probation Start Date:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {employee.probationStartDate || "-"}
                      </MDTypography>
                    </Grid>
                    <Grid item xs={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{
                          fontSize: "14px",
                          fontWeight: "600",
                          minWidth: "150px",
                          fontFamily: properties.fontFamily
                        }}
                      >
                        Probation End Date:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {employee.probationEndDate || "-"}
                      </MDTypography>
                    </Grid>

                    <Grid item xs={6} container alignItems="center">
                      <MDTypography
                        variant="caption"
                        sx={{
                          fontSize: "14px",
                          fontWeight: "600",
                          minWidth: "150px",
                          fontFamily: properties.fontFamily
                        }}
                      >
                        Designation:
                      </MDTypography>
                      <MDTypography variant="caption" sx={{fontSize: "14px", fontWeight: "400"}}>
                        {employee.designation || "-"}
                      </MDTypography>
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
            </Card>
          </AppBar>

          <MDBox pt={1}>
            <Card sx={{borderRadius: "5px", border: "1px solid #D3D3D3", background: "#fff", p: 4}}>
              <Typography
                pb={2}
                sx={{fontSize: "16px", fontWeight: "600", fontFamily: properties.fontFamily}}
                color="textPrimary"
              >
                {" "}
                Change Employee Notice Period{" "}
              </Typography>

              <Grid container spacing={3}>
                <Grid item xs={5}>
                  <FormControl fullWidth error={!!errors.noticePeriod}>
                    <InputLabel id="notice-period-label">
                      Resignation Notice Period<span style={{color: "red"}}>*</span>
                    </InputLabel>

                    <Select
                      labelId="notice-period-label"
                      label="Resignation Notice Period*"
                      name="noticePeriod"
                      value={formData.noticePeriod || ""}
                      onChange={handleChange}
                      sx={{height: 45}}
                    >
                      <MenuItem value="">
                        <em>Select Month</em>
                      </MenuItem>
                      <MenuItem value="1">1 Month</MenuItem>
                      <MenuItem value="2">2 Months</MenuItem>
                      <MenuItem value="3">3 Months</MenuItem>
                      <MenuItem value="4">4 Months</MenuItem>
                      <MenuItem value="5">5 Months</MenuItem>
                      <MenuItem value="6">6 Months</MenuItem>
                    </Select>

                    {errors.noticePeriod && <FormHelperText>{errors.noticePeriod}</FormHelperText>}
                  </FormControl>
                </Grid>

                <Grid item xs={6}></Grid>

                <Grid item xs={5}>
                  <FormControl fullWidth error={!!errors.extensionPeriod}>
                    <InputLabel id="termination-period-label">
                      Termination Notice Period<span style={{color: "red"}}>*</span>
                    </InputLabel>

                    <Select
                      labelId="termination-period-label"
                      label="Termination Notice Period*"
                      name="extensionPeriod"
                      value={formData.extensionPeriod || ""}
                      onChange={handleChange}
                      sx={{height: 45}}
                    >
                      <MenuItem value="">
                        <em>Select Month</em>
                      </MenuItem>
                      <MenuItem value="1">1 Month</MenuItem>
                      <MenuItem value="2">2 Months</MenuItem>
                      <MenuItem value="3">3 Months</MenuItem>
                      <MenuItem value="4">4 Months</MenuItem>
                      <MenuItem value="5">5 Months</MenuItem>
                      <MenuItem value="6">6 Months</MenuItem>
                    </Select>

                    {errors.extensionPeriod && (
                      <FormHelperText>{errors.extensionPeriod}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>

                <Grid item xs={12} sx={{display: "flex", justifyContent: "flex-end"}}>
                  <MDButton
                    variant="gradient"
                    color="info"
                    onClick={handleSubmit}
                    disabled={isButtonDisabled}
                  >
                    Change Notice Period
                  </MDButton>
                </Grid>
              </Grid>
            </Card>
          </MDBox>
          <Snackbar
            open={open}
            anchorOrigin={{vertical: "top", horizontal: "right"}}
            autoHideDuration={1200}
            onClose={handleClose}
          >
            <Alert onClose={handleClose} severity={snakColor} variant="filled">
              {snakMessage}
            </Alert>
          </Snackbar>
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default ChangeNoticePeriod;
